


































import { Component, Vue, Prop } from "vue-property-decorator";
import { systemInformation } from "../../api/systeminformation/systeminformation";
@Component({
  name: "AddSystemInformation"
})
export default class AddSystemInformation {
  public subject: string = "";
  public content: string = "";
  public row: any = {};
  public created() {
    this.checkEdit();
  }
  public submit() {
    if (this.row.id == undefined) {
      systemInformation
        .sendMessage(
          this.$store.getters.getToken,
          { subject: this.subject, content: this.content },
          this.$store.getters.getHost
        )
        .then(r => {
          if (r.status == 400) {
            this.$message.error(r.error);
          } else {
            this.$store.dispatch("updateCurrentObject", {});
            this.$store.dispatch(
              "updateCurrentComponent",
              "SystemInformationList"
            );
            this.$message.success("System Information Added");
            this.$router.replace({
              name: "load"
            });
          }
        });
    } else {
      systemInformation
        .editMessage(
          this.$store.getters.getToken,
          { subject: this.subject, content: this.content, id: this.row.id },
          this.$store.getters.getHost
        )
        .then(r => {
          if (r.status == 400) {
            this.$message.error(r.error);
          } else {
            this.$store.dispatch("updateCurrentObject", {});
            this.$store.dispatch(
              "updateCurrentComponent",
              "SystemInformationList"
            );
            this.$message.success("System Information Edited");
            this.$router.replace({
              name: "load"
            });
          }
        });
    }
  }
  public beforeDestroy() {
    this.$store.dispatch("updateCurrentObject", {});
  }
  public checkEdit() {
    this.row = this.$store.getters.getCurrentObject;
    if (this.row.id != undefined) {
      this.subject = this.row.subject;
      this.content = this.row.content;
    }
  }
}
